import { creneauxSorter2, creneauxSorter3 } from './creneaux_sorter.js';

export default function sortElevesCreneaux(creneaux) {

    let allEleves = [];
    let allCreneaux = [];
    let dateList = [];

    creneaux.map((creneauEleve) => { // for every line in CreneauEleve Table...
        //// -- We want a list of eleves

        // if eleve not in the list already...
        if (allEleves.filter((eleve) => eleve.id === creneauEleve.Eleve.id_eleve).length === 0) {
            allEleves.push({  //... we add this eleve to the list, with his infos reformated for global state "Eleves" 
                id: creneauEleve.Eleve.id_eleve,
                prenom: creneauEleve.Eleve.prenom,
                age: creneauEleve.Eleve.age,
                nb_cours: creneauEleve.Eleve.nb_cours,
            });
            allEleves.sort((e1, e2) => e1.id > e2.id ? 1 : -1); // We sort the list of eleves, as they "arrive" in disorder
        }

        if (allCreneaux.filter((creneau) => creneau.id === creneauEleve.Creneau.id_creneau).length === 0) {
            allCreneaux.push({
                eleves: [{ id: creneauEleve.Eleve.id_eleve, prenom: creneauEleve.Eleve.prenom }],
                date: creneauEleve.Creneau.date,
                horaire: creneauEleve.Creneau.horaire,
                id: creneauEleve.Creneau.id_creneau
            });
            allCreneaux.sort((d1, d2) => creneauxSorter2(d1, d2));
        }
        else {
            allCreneaux.find((c) => c.id === creneauEleve.Creneau.id_creneau).eleves.push({ id: creneauEleve.Eleve.id_eleve, prenom: creneauEleve.Eleve.prenom });
        }


        dateList.push(creneauEleve.Creneau.date);


    });// end of map

    let dateSet = new Set(dateList);
    let newDatesList = Array.from(dateSet); //we need this list of date to display a calendar with only days with creneaux
    newDatesList.sort((d1, d2) => creneauxSorter3(d1, d2));

    return ({ eleves: allEleves, creneaux: allCreneaux, dateList: newDatesList })
}//end of function